import { Suspense, useMemo } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes } from "react-router-dom";
import { StaticRouter } from "react-router-dom/server";
import { usePageContext } from "vike-react/usePageContext";
import { store } from "../../../src/store/store";
import WorkerServiceDetails from "../../../src/pages/worker/service";
import RouteLoadingFallback from "../../../src/shared/RouteLoadingFallback";
import SiteDocumentTitleSync from "../../../src/components/common/SiteDocumentTitleSync";
import {
  createPublicRoutes,
  renderAppMainRoutes,
} from "../../../src/router/appMainRoutes";

export default function WorkerSlugPage() {
  const pageContext = usePageContext();
  const isServer = typeof window === "undefined";
  const location = pageContext.urlPathname || "/";
  const pageProps = (pageContext as any).pageProps || {};

  const publicRoutes = useMemo(
    () =>
      createPublicRoutes({
        workerDetail: (
          <WorkerServiceDetails
            {...({
              initialWorker: pageProps.initialWorker,
              initialReviews: pageProps.initialReviews,
            } as any)}
          />
        ),
      }),
    [pageProps.initialWorker, pageProps.initialReviews]
  );

  const tree = (
    <Suspense fallback={<RouteLoadingFallback />}>
      <SiteDocumentTitleSync />
        <Routes>{renderAppMainRoutes({ publicRoutes })}</Routes>
    </Suspense>
  );

  return (
    <Provider store={store}>
      {isServer ? (
        <StaticRouter location={location}>{tree}</StaticRouter>
      ) : (
        <BrowserRouter>{tree}</BrowserRouter>
      )}
    </Provider>
  );
}
